import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  sender_id: yup.string().required("Sender ID is required"),
  message_body: yup.string().required("Message content is required"),
});

export const useValidation = ({ ...rest }) => {
  return useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      ...rest,
    },
  });
};
